import { generateKeysAndUserId } from '../../engine/helpers/generateKeysAndUserId';
import { formBroadcastPath, generateStreamId, parseBroadcastFromUrl, } from '../../utils/url';
import { BroadcastStateServiceOutput, } from '../broadcaststate/BroadcastStateServiceOutput';
import { generateBroadcastId, } from '../schedule/ScheduledBroadcast';
import { ScheduleService } from '../schedule/ScheduleService';
export class BroadcastStateService {
    static instance;
    output;
    activeBroadcast;
    constructor() {
        this.output = new BroadcastStateServiceOutput();
        const broadcast = parseBroadcastFromUrl(new URL(window.location.href));
        if (broadcast !== undefined) {
            const scheduledBroadcast = ScheduleService.getInstance().getScheduledBroadcast(broadcast.streamId);
            const roleProperties = scheduledBroadcast !== undefined
                ? {
                    myRole: 'broadcaster',
                    broadcasterPrivateKey: scheduledBroadcast.broadcasterPrivateKey,
                }
                : {
                    myRole: 'viewer',
                };
            this.setActiveBroadcast({
                ...broadcast,
                ...roleProperties,
            });
        }
    }
    async init() { }
    static getInstance() {
        if (!BroadcastStateService.instance) {
            BroadcastStateService.instance = new BroadcastStateService();
        }
        return BroadcastStateService.instance;
    }
    static getNotificationInterface() {
        return BroadcastStateService.getInstance();
    }
    static getOutput() {
        return BroadcastStateServiceOutput.getReactiveOutput();
    }
    notifySetActiveBroadcast(broadcast) {
        this.setActiveBroadcast(broadcast);
    }
    notifyActivateBroadcast(savedBroadcast, onActivate) {
        let broadcast;
        // If we are not activating an already saved broadcast, save the newly created one (TODO rename this e.g. to SavedBroadcasts?)
        if (savedBroadcast === undefined) {
            const streamId = generateStreamId();
            const { privateKey, userId, aesKey } = generateKeysAndUserId();
            broadcast = {
                id: generateBroadcastId(),
                name: 'Broadcast',
                startsAt: Date.now(),
                streamId,
                broadcasterPrivateKey: privateKey,
                broadcasterUserId: userId,
                aesKey,
            };
            ScheduleService.getInstance().notifyAddScheduledBroadcast(broadcast);
        }
        else {
            broadcast = savedBroadcast;
        }
        BroadcastStateService.getInstance().notifySetActiveBroadcast({
            ...broadcast,
            myRole: 'broadcaster',
        });
        onActivate?.(formBroadcastPath(broadcast));
    }
    setActiveBroadcast(broadcast) {
        this.activeBroadcast = broadcast;
        this.output.setActiveBroadcast(broadcast);
    }
    getActiveBroadcast() {
        return this.activeBroadcast;
    }
    getRequiredActiveBroadcast() {
        if (this.activeBroadcast === undefined) {
            throw new Error('Invalid context: no active broadcast');
        }
        return this.activeBroadcast;
    }
}
